import React from 'react';
import { useParams } from 'react-router-dom';
import Location from '@/assets/smartcity/loc-landing-icon.svg';
import { useLocationDetails } from '@/domains/landing-page/hooks/useLocationDetails';
import Button from '@/shared/components/ui/Button';

const buttonLabel: Record<string, string> = {
  idle: 'Share My Location',
  locating: 'Getting your location...',
  submitting: 'Sharing...',
  success: 'Location Shared',
  error: 'Try Again',
};

const LocationDetails = () => {
  const { token } = useParams<{ token: string }>();
  const { status, errorMessage, result, shareLocation } = useLocationDetails(token);

  const isBusy = status === 'locating' || status === 'submitting';

  return (
    <section className="w-full h-screen bg-[#F3F6FE] p-6">
      <div className="p-6  shadow-[0_4px_4px_0_rgba(0,0,0,0.16)] bg-db-card bg-db-border rounded-[12px] w-full h-fit flex flex-col gap-6">
        <div className="flex flex-col gap-2 justify-center items-center">
          <img src={Location} alt="loaction-icon" />
          <h3 className="h5bold text-center">Share Your Current Location</h3>
          <p className="title2 text-db-text-grey text-center">
            To help our ambulance team reach you faster, please share your current location.
          </p>
        </div>

        {result && (
          <div className="flex flex-col gap-3 justify-center border w-full border-[#C2D2E2] rounded-[12px] p-4">
            <h4 className="title text-text-blue-100 capitalize text-start">Location Details</h4>
            <div className="grid grid-cols-2 gap-3 items-center">
              <div className="flex flex-col gap-1">
                <span className="text-text-grey body1">Latitude</span>
                <span className="title2 text-black">{result.latitude}</span>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-text-grey body1">Longitude</span>
                <span className="title2 text-black">{result.longitude}</span>
              </div>
            </div>
            {result.address && (
              <div className="flex flex-col gap-1">
                <span className="text-text-grey body1">Details</span>
                <p className="title2 text-black">{result.address}</p>
              </div>
            )}
          </div>
        )}

        {status === 'error' && (
          <p className="title2 text-center text-text-danger-500">{errorMessage}</p>
        )}

        <div className="w-full flex justify-center">
          <Button
            onClick={shareLocation}
            disabled={isBusy || status === 'success'}
            variant="default"
            label={buttonLabel[status]}
            customButton=""
            className="flex-1 btn-fill-blue capitalize text-[20px] disabled:pointer-events-auto disabled:!cursor-not-allowed "
          />
        </div>
      </div>
    </section>
  );
};

export default LocationDetails;
